<template>
  <div
    class="ds-grid__item"
    data-cy="ds-grid__item"
  >
    <slot />
  </div>
</template>
